import { MODAL_SHOW, MODAL_HIDE } from '../../constants/actionTypes';

const INITIAL_STATE = {
  isVisible: false,
  currentTarget: '',
};

const applyShowModal = (state, action) => ({
  isVisible: true,
  currentTarget: action.target,
});

const applyHideModal = (state, action) => ({
  isVisible: false,
  currentTarget: '',
});

const modalReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_SHOW:
      return applyShowModal(state, action);
    case MODAL_HIDE:
      return applyHideModal(state, action);
    default:
      return state;
  }
};

export default modalReducer;
